
import $ from '@/fly'
const subUrlPrefix = 'mobile'

export function listTask(search) {
  return $.get(subUrlPrefix + '/list/task', search)
}

export function listRecord(search) {
  return $.get(subUrlPrefix + '/list/record', search)
}

export function paperNews(search) {
  return $.get(subUrlPrefix + '/paperNews', search)
}

export function submit(data) {
  return $.post(subUrlPrefix + '/submit', data)
}
